import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  color?: 'primary' | 'secondary'
}

const SummaryItem = ({ children, color = 'primary' }: Props) => {
  return (
    <div
      className={clsx(
        color == 'secondary' && 'bg-fill-surface-secondary',
        `border-primary flex w-full flex-col items-center justify-center gap-2 border-r p-3.5 last:border-r-0`
      )}
    >
      {children}
    </div>
  )
}

export default SummaryItem
